export const getElementSize = (
  el: HTMLElement,
): {
  height: number;
  width: number;
  paddingTop: number;
  paddingRight: number;
  paddingBottom: number;
  paddingLeft: number;
  marginTop: number;
  marginRight: number;
  marginBottom: number;
  marginLeft: number;
  boxSizing: string;
} => {
  const {
    height,
    width,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    boxSizing,
  } = window.getComputedStyle(el);

  return {
    height: parseFloat(height),
    width: parseFloat(width),
    paddingTop: parseFloat(paddingTop),
    paddingRight: parseFloat(paddingRight),
    paddingBottom: parseFloat(paddingBottom),
    paddingLeft: parseFloat(paddingLeft),
    marginTop: parseFloat(marginTop),
    marginRight: parseFloat(marginRight),
    marginBottom: parseFloat(marginBottom),
    marginLeft: parseFloat(marginLeft),
    boxSizing,
  };
};

export const getAbsoluteHeight = (el: HTMLElement): number => {
  const size = getElementSize(el);
  const marginRight = size.marginBottom + size.marginTop;

  return Math.ceil(el.offsetHeight + marginRight);
};
